import React from 'react'

export type WindowClickSignaler = (e: MouseEvent) => boolean /* isMine */

export function getStillInsideWindowClickSignaler<T extends HTMLElement>(ref: React.RefObject<T>) {
  return (e: MouseEvent) => !!ref.current?.contains(e.target as Node)
}
